import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import { Laugh } from 'lucide-react';
import { emojis, stickers } from "../../../global-components/src/utils/text";
import { Icon } from "../../../global-components/src/components/icon";
import GifModal from "../../gif-picker/gif-picker";
import { useAuth } from "../../../global-components/src";

type typeEmoji = "emoji" | "sticky" | "gif";

type EmojiProps = {
    textareaRef: React.RefObject<HTMLTextAreaElement | null>;
    updateText: (newText: string) => void;
    handleClickSticky?: (sticky: string) => void;
    handleClickGif?: (gif: string) => void;
    text: string; 
    defaultType?: typeEmoji; 
    bottom?: string | number; 
    buttonRef?: React.RefObject<HTMLDivElement | null>; // Adicionando referência do botão
};

const EmojiPicker: React.FC<EmojiProps> = ({ textareaRef, updateText, handleClickSticky, handleClickGif, text, buttonRef, bottom, defaultType  }) => {
    const [query, setQuery] = useState("");
    const [filteredEmojis, setFilteredEmojis] = useState<string[]>([]);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [typeEmoji, setTypeEmoji] = useState<typeEmoji>(defaultType ?? "emoji");
    const [isEmojiSelected, setIsEmojiSelected] = useState(false); // Novo estado
    const { user } = useAuth();

    useEffect(() => {
        if (typeEmoji === "emoji") {
            // textareaRef.current?.focus();
        }
    }, [typeEmoji]);

    const handleInput = () => {
        if (!textareaRef.current) return;

        const textarea = textareaRef.current;
        const value = textarea.value;
        const cursor = textarea.selectionStart;

        const lastColonIndex = value.lastIndexOf(":", cursor - 1);
        if (lastColonIndex === -1) {
            setIsDropdownVisible(false);
            return;
        }

        const charBeforeColon =
            lastColonIndex === 0 ? "" : value[lastColonIndex - 1];

        // aceita início, espaço ou quebra de linha
        const isValidStart =
            charBeforeColon === "" ||
            charBeforeColon === " " ||
            charBeforeColon === "\n";

        if (!isValidStart) {
            setIsDropdownVisible(false);
            return;
        }

        const searchQuery = value.substring(lastColonIndex + 1, cursor);

        // não permitir espaço dentro do emoji
        if (searchQuery.includes(" ")) {
            setIsDropdownVisible(false);
            return;
        }

        setQuery(searchQuery);

        const list = Object.keys(typeEmoji === "emoji" ? emojis : stickers)
            .filter((e) => e.startsWith(searchQuery));

        setFilteredEmojis(list);
        setIsDropdownVisible(list.length > 0);
    };


    const handleClickItem = (type: typeEmoji, emoji: string) => {
        if(type == "sticky" && handleClickSticky) return handleClickSticky(emoji)
    }

    // useEffect(() => {
    //     if (typeEmoji === "sticky" && query === "") {
    //         const allStickers = Object.keys(stickers);
    //         setFilteredEmojis(allStickers);
    //         setIsDropdownVisible(true);
    //     }
    // }, [typeEmoji, query]);

    // Adiciona um listener de clique fora do dropdown
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node) &&
                textareaRef.current &&
                !textareaRef.current.contains(event.target as Node)
            ) {
                const newText = textareaRef.current.value.replace(/:\s*$/, '');

                const textarea = textareaRef.current;
                // Atualiza o valor do textarea
                textarea.value = newText;
                // Chama a função para atualizar o texto no componente pai
                updateText(newText);
                textarea.focus();
                setIsEmojiSelected(true); 
                textarea.setSelectionRange(newText.length, newText.length);
                setFilteredEmojis([]);
                // textareaRef?.current?.value.slice(-1);
                // setIsDropdownVisible(false); // Fecha o dropdown
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        textarea.addEventListener("input", handleInput);
        textarea.addEventListener("keyup", handleInput);
        textarea.addEventListener("click", handleInput);
        textarea.addEventListener("mouseup", handleInput);

        return () => {
            textarea.removeEventListener("input", handleInput);
            textarea.removeEventListener("keyup", handleInput);
            textarea.removeEventListener("click", handleInput);
            textarea.removeEventListener("mouseup", handleInput);
        };
    }, []);



    // Chame handleInput quando o texto mudar
    useEffect(() => {
        handleInput(); // Chama a função para atualizar o dropdown
    }, [text, typeEmoji]);

    const insertEmoji = (emoji: string) => {
        if (!textareaRef.current) return;
        const textarea = textareaRef.current;
        const currentText = textarea.value;
        const cursorPosition = textarea.selectionStart;
        const lastColonIndex = currentText.lastIndexOf(":", cursorPosition - 1);

        if (lastColonIndex !== -1) {
            const beforeEmoji = currentText.substring(0, lastColonIndex);
            const afterEmoji = currentText.substring(cursorPosition);
            const newText = beforeEmoji + emoji + " " + afterEmoji;

            // Atualiza o valor do textarea
            textarea.value = newText;
            // Chama a função para atualizar o texto no componente pai
            updateText(newText);
            textarea.focus();
            setIsEmojiSelected(true); 
            textarea.setSelectionRange(newText.length, newText.length);
            setFilteredEmojis([]);

            // Atualiza a lista de emojis
            handleInput();
        }
    };

    const dropdownStyle: React.CSSProperties = {
        left: 5,
        right: 5,
        bottom: bottom,
    };

    return (
        isDropdownVisible && (
            <div ref={dropdownRef} className={`user-select-none ${typeEmoji === "emoji" ? "emoji-dropdown" : "sticky-dropdown"} `}  style={dropdownStyle}>
                <div className="emoji-container">
                    {typeEmoji == "gif" ? (
                        <GifModal
                            onSelect={(gif: any) => {
                                console.log(gif);
                                
                                if(handleClickGif)
                                    handleClickGif(gif.images.original.url)
                            }}
                        />
                    ): (
                        <>
                            {filteredEmojis.map((emoji) => (
                                <div
                                    key={emoji}
                                    className={typeEmoji == "emoji" ? "emoji-option" : "sticky-option"}
                                    onClick={() => {insertEmoji(emoji); handleClickItem(typeEmoji, emoji)}}
                                    dangerouslySetInnerHTML={{ __html: typeEmoji === "emoji" ? emojis[emoji] : stickers[emoji] }}
                                />
                            ))}
                        </>
                    )}
                </div>

                {/* {showGif && (
                    <GifModal
                        onClose={() => setShowGif(false)}
                        onSelect={(gif: any) => {
                            setSelectedGif(gif)
                            setShowGif(false)

                            // 👉 salva a URL no texto ou separado
                            // setText(prev => prev + ` ${gif.images.original.url}`)
                        }}
                        style={{ bottom: bottomPadding + textareaHeight + (window.innerWidth <=850 ? 5 : 15) }}
                    />
                )} */}

                <div className="row div-change-type-icon"> 
                    <div className={`col cursor-pointer ${typeEmoji === "emoji" ? "active" : ""}`} onClick={() => { setTypeEmoji("emoji"); setIsEmojiSelected(false); }}>
                        <Laugh/>
                    </div>
                    <div className={`col cursor-pointer ${typeEmoji === "sticky" ? "active" : ""}`} onClick={() => { setTypeEmoji("sticky"); setIsEmojiSelected(false); }}>
                        <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="" fill="none"><title>expressions</title><path d="M8.49893 10.2521C9.32736 10.2521 9.99893 9.5805 9.99893 8.75208C9.99893 7.92365 9.32736 7.25208 8.49893 7.25208C7.6705 7.25208 6.99893 7.92365 6.99893 8.75208C6.99893 9.5805 7.6705 10.2521 8.49893 10.2521Z" fill="currentColor"></path><path d="M17.0011 8.75208C17.0011 9.5805 16.3295 10.2521 15.5011 10.2521C14.6726 10.2521 14.0011 9.5805 14.0011 8.75208C14.0011 7.92365 14.6726 7.25208 15.5011 7.25208C16.3295 7.25208 17.0011 7.92365 17.0011 8.75208Z" fill="currentColor"></path><path fillRule="evenodd" clipRule="evenodd" d="M16.8221 19.9799C15.5379 21.2537 13.8087 21.9781 12 22H9.27273C5.25611 22 2 18.7439 2 14.7273V9.27273C2 5.25611 5.25611 2 9.27273 2H14.7273C18.7439 2 22 5.25611 22 9.27273V11.8141C22 13.7532 21.2256 15.612 19.8489 16.9776L16.8221 19.9799ZM14.7273 4H9.27273C6.36068 4 4 6.36068 4 9.27273V14.7273C4 17.6393 6.36068 20 9.27273 20H11.3331C11.722 19.8971 12.0081 19.5417 12.0058 19.1204L11.9935 16.8564C11.9933 16.8201 11.9935 16.784 11.9941 16.7479C11.0454 16.7473 10.159 16.514 9.33502 16.0479C8.51002 15.5812 7.84752 14.9479 7.34752 14.1479C7.24752 13.9479 7.25585 13.7479 7.37252 13.5479C7.48919 13.3479 7.66419 13.2479 7.89752 13.2479L13.5939 13.2479C14.4494 12.481 15.5811 12.016 16.8216 12.0208L19.0806 12.0296C19.5817 12.0315 19.9889 11.6259 19.9889 11.1248V9.07648H19.9964C19.8932 6.25535 17.5736 4 14.7273 4ZM14.0057 19.1095C14.0066 19.2605 13.9959 19.4089 13.9744 19.5537C14.5044 19.3124 14.9926 18.9776 15.4136 18.5599L18.4405 15.5576C18.8989 15.1029 19.2653 14.5726 19.5274 13.996C19.3793 14.0187 19.2275 14.0301 19.0729 14.0295L16.8138 14.0208C15.252 14.0147 13.985 15.2837 13.9935 16.8455L14.0057 19.1095Z" fill="currentColor"></path></svg>
                    </div>

                    {handleClickGif && (user?.stamps.includes("blue") || user?.position === 1) && (
                        <div className={`col cursor-pointer ${typeEmoji === "gif" ? "active" : ""}`} onClick={() => { setTypeEmoji("gif"); setIsEmojiSelected(false); }}>
                            <Icon color="var(--color-text-post)" name="gif_box"/>
                        </div>
                    )}
                </div>
            </div>
        )
    );
};

export default EmojiPicker;
